import { compareDimensions } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function CompareSection() {
  return (
    <section id="compare" className="scroll-mt-32 bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="主站与分站对照"
          icon="ri-contrast-2-line"
          title="区别不靠猜，五个维度逐条比"
          desc="黑料网5区别集中体现在内容划分、更新节奏与板块玩法上。这里用同一套维度把主站和分站并排放好，黑料网5不同之处可以直接对照着看，不用自己拼凑印象。"
        />

        <div className="mt-10 flex flex-wrap items-center gap-3">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-secondary-100 text-secondary-900 font-label text-xs">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-circle-fill text-[6px]"></i>
            </span>
            主站 · 综合信息流
          </span>
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-accent-100 text-accent-900 font-label text-xs">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-circle-fill text-[6px]"></i>
            </span>
            分站 · 按方向独立成型
          </span>
        </div>

        <div className="mt-6 rounded-lg border border-background-200 overflow-hidden">
          <div className="hidden md:grid grid-cols-12 bg-background-100 border-b border-background-200">
            <div className="col-span-2 px-5 py-4 font-label text-xs text-foreground-600 tracking-wide">
              对照维度
            </div>
            <div className="col-span-5 px-5 py-4 font-label text-xs text-foreground-800 tracking-wide border-l border-background-200">
              主站
            </div>
            <div className="col-span-5 px-5 py-4 font-label text-xs text-accent-800 tracking-wide border-l border-background-200">
              分站（黑料网5分站）
            </div>
          </div>

          {compareDimensions.map((row, index) => (
            <div
              key={row.dimension}
              className={`grid grid-cols-1 md:grid-cols-12 ${
                index % 2 === 1 ? "bg-background-50" : "bg-background-100/40"
              } ${index !== 0 ? "border-t border-background-200" : ""}`}
            >
              <div className="col-span-2 px-5 pt-5 pb-2 md:py-5 flex items-center gap-2">
                <span className="md:hidden w-4 h-4 flex items-center justify-center text-primary-600">
                  <i className="ri-subtract-line text-[14px]"></i>
                </span>
                <span className="font-heading text-sm font-semibold text-foreground-950">
                  {row.dimension}
                </span>
              </div>
              <div className="col-span-5 px-5 py-3 md:py-5 md:border-l md:border-background-200 flex items-start gap-2.5">
                <span className="mt-1 w-2 h-2 shrink-0 rounded-full bg-secondary-400"></span>
                <p className="font-body text-sm leading-relaxed text-foreground-700">
                  {row.main}
                </p>
              </div>
              <div className="col-span-5 px-5 py-3 md:py-5 md:border-l md:border-background-200 flex items-start gap-2.5">
                <span className="mt-1 w-2 h-2 shrink-0 rounded-full bg-accent-500"></span>
                <p className="font-body text-sm leading-relaxed text-foreground-900">
                  {row.branch}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-5 flex items-start gap-2 font-label text-xs text-foreground-500">
          <span className="w-4 h-4 mt-0.5 shrink-0 flex items-center justify-center text-primary-600">
            <i className="ri-information-line text-[14px]"></i>
          </span>
          以上维度按统一口径整理，便于横向比对；实际浏览时可按自己关心的方向选择性查看。
        </p>
      </div>
    </section>
  );
}